import { Route, Routes } from 'react-router';
import { useAuthContext } from '@contexts/auth';
import ProtectedRoute from '@components/ProtectedRoute';
import Loading from '@components/Loading';

import Login from './Login';
import OtpCode from './Otp';
import Registration from './Registration';
import Dashboard from './Dashboard';
import Customers from './Customers/Main';
import UpsertCustomer from './Customers/Upsert';
import CustomerDetails from './Customers/Details';
import Portfolio from './Portfolio';
import DispositionOption from './DispositionOption';
import Campaign from './Campaign';
import CampaignExecution from './CampaignExecution/Main';
import CampaignExecutionMyDispositions from './CampaignExecution/MyDispositions';
import User from './User/Main';
import UserRoles from './User/Roles';
import Teams from './Teams';
import NotFound from './NotFound';
import ForgotPassword from './ForgotPassword';
import NewPassword from './NewPassword';
import SalesFunnel from './SalesFunnel';
import FunnelEditor from './SalesFunnel/Editor';
import MyAttendances from './MyAttendances';
import CustomerInteraction from './CustomerInteraction';

const AppRoutes = () => {
  const { checkIfHasRole, isLoadingPermissions } = useAuthContext();

  if (isLoadingPermissions) return <Loading />;

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="inserir-codigo" element={<OtpCode />} />
      <Route path="cadastro/:code" element={<Registration />} />
      <Route path="esqueci-senha" element={<ForgotPassword />} />
      <Route path="nova-senha/:code" element={<NewPassword />} />

      <Route element={<ProtectedRoute />}>
        <Route path="painel" element={<Dashboard />}>
          {checkIfHasRole('CAN_VIEW_CUSTOMERS') && (
            <Route path="clientes">
              <Route index element={<Customers />} />
              {checkIfHasRole('CAN_CREATE_CUSTOMERS') && (
                <Route path="criar" element={<UpsertCustomer />} />
              )}
              {checkIfHasRole('CAN_EDIT_CUSTOMERS') && (
                <Route path="editar/:id" element={<UpsertCustomer />} />
              )}
              {checkIfHasRole('CAN_DETAIL_CUSTOMERS') && (
                <Route path=":id" element={<CustomerDetails />} />
              )}
            </Route>
          )}

          {checkIfHasRole('CAN_READ_PORTFOLIO') && (
            <Route path="portfolios" element={<Portfolio />} />
          )}

          {checkIfHasRole('CAN_READ_CAMPAIGNS') && (
            <Route path="campanhas" element={<Campaign />} />
          )}

          {checkIfHasRole('CAN_VIEW_CAMPAIGN_EXECUTION') && (
            <Route path="atendimentos">
              <Route index element={<CampaignExecution />} />
              {checkIfHasRole('CAN_PERFORM_CAMPAIGN_EXECUTION') && (
                <Route path=":executionId/cliente" element={<CustomerInteraction />} />
              )}
              {checkIfHasRole('CAN_PERFORM_CAMPAIGN_EXECUTION') && (
                <Route path=":executionId/meus-atendimentos" element={<CampaignExecutionMyDispositions />} />
              )}
            </Route>
          )}

          {(checkIfHasRole('CAN_PERFORM_WALKIN') || checkIfHasRole('CAN_PERFORM_CAMPAIGN_EXECUTION')) && (
            <Route path="meus-atendimentos">
              <Route index element={<MyAttendances />} />
              <Route path="cliente" element={<CustomerInteraction />} />
            </Route>
          )}

          {checkIfHasRole('CAN_READ_TABULATION_OPTIONS') && (
            <Route path="opcoes-de-tabulacao" element={<DispositionOption />} />
          )}
          {checkIfHasRole('CAN_READ_SALESFUNNELS') && (
            <Route path="funil-de-vendas">
              <Route index element={<SalesFunnel />} />
              {checkIfHasRole('CAN_MANAGE_SALESFUNNELS') && (
                <Route path="editor" element={<FunnelEditor />} />
              )}
            </Route>
          )}

          {checkIfHasRole('CAN_VIEW_USERS') && (
            <Route path="usuarios">
              <Route index element={<User />} />
              {checkIfHasRole('CAN_MANAGE_USERS') && (
                <Route path=":id/permissoes" element={<UserRoles />} />
              )}
            </Route>
          )}
          {checkIfHasRole('CAN_READ_TEAMS') && (
            <Route path="equipes" element={<Teams />} />
          )}
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
